/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TerritoryWithPolygonResponseGeoJson } from './TerritoryWithPolygonResponseGeoJson';
import {
    TerritoryWithPolygonResponseGeoJsonFromJSON,
    TerritoryWithPolygonResponseGeoJsonFromJSONTyped,
    TerritoryWithPolygonResponseGeoJsonToJSON,
    TerritoryWithPolygonResponseGeoJsonToJSONTyped,
} from './TerritoryWithPolygonResponseGeoJson';

/**
 * 
 * @export
 * @interface TerritoryWithPolygonResponse
 */
export interface TerritoryWithPolygonResponse {
    /**
     * Territory name
     * @type {string}
     * @memberof TerritoryWithPolygonResponse
     */
    name?: string;
    /**
     * Territory type
     * @type {string}
     * @memberof TerritoryWithPolygonResponse
     */
    type?: string;
    /**
     * 
     * @type {TerritoryWithPolygonResponseGeoJson}
     * @memberof TerritoryWithPolygonResponse
     */
    geoJson?: TerritoryWithPolygonResponseGeoJson;
}

/**
 * Check if a given object implements the TerritoryWithPolygonResponse interface.
 */
export function instanceOfTerritoryWithPolygonResponse(value: object): value is TerritoryWithPolygonResponse {
    return true;
}

export function TerritoryWithPolygonResponseFromJSON(json: any): TerritoryWithPolygonResponse {
    return TerritoryWithPolygonResponseFromJSONTyped(json, false);
}

export function TerritoryWithPolygonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerritoryWithPolygonResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
        'geoJson': json['geoJson'] == null ? undefined : TerritoryWithPolygonResponseGeoJsonFromJSON(json['geoJson']),
    };
}

export function TerritoryWithPolygonResponseToJSON(json: any): TerritoryWithPolygonResponse {
    return TerritoryWithPolygonResponseToJSONTyped(json, false);
}

export function TerritoryWithPolygonResponseToJSONTyped(value?: TerritoryWithPolygonResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': value['type'],
        'geoJson': TerritoryWithPolygonResponseGeoJsonToJSON(value['geoJson']),
    };
}

